import {CreateLiveEventFormValues} from "../reducers/create-live-event/types";
import {createLiveEventDto} from "../create-live-event-service";
import {CreateLiveEventApiResponse} from "../../../../react-query-hooks/live-events/create-live-event/types";
import {useCreateLiveEventContext} from "../context/create-live-event";
import {useCreateLiveEvent, LiveEvent} from "../../../../features/live-events";

/**
 * Adapts domain LiveEvent to legacy CreateLiveEventApiResponse format.
 * Allows v2 API to be used while maintaining compatibility with existing consumers.
 */
function toLegacyFormat(event: LiveEvent): Partial<CreateLiveEventApiResponse> {
  return {
    id: event.id,
    userId: event.userId,
    name: event.name,
    slug: event.slug,
    description: event.description,
    topic_type: event.topicType,
    video_platform: event.videoPlatform as "dailyCo" | "zoom" | "",
    roomId: event.roomId,
    callPrice: event.callPrice,
    callPriceCurrency: event.callPriceCurrency,
    attendees: event.attendees,
    reference: event.reference,
    tiny_url: event.tinyUrl,
    cover_image: event.coverImage,
    request_phone_number: event.requestPhoneNumber,
    hide_from_menu: event.hideFromMenu,
    url_redirect: event.urlRedirect,
    is_custom_room: event.isCustomRoom,
    createdAt: event.createdAt,
    updatedAt: event.updatedAt ?? event.createdAt,
  };
}

interface HookResult {
  createLiveEvent(values: CreateLiveEventFormValues): void;
  wasLiveEventCreated: boolean;
  isCreatingLiveEvent: boolean;
  responseData?: Partial<CreateLiveEventApiResponse>;
}

export function useCreateLiveEventHook(): HookResult {
  const {dispatch} = useCreateLiveEventContext();
  const createLiveEventMutation = useCreateLiveEvent();

  const createLiveEvent = (values: CreateLiveEventFormValues) => {
    createLiveEventMutation.mutate(createLiveEventDto(values), {
      onSuccess(data) {
        dispatch({
          type: "go-to-cover-images-upload-form-step",
          payload: {apiResponse: toLegacyFormat(data), formData: values},
        });
      },
    });
  };
  return {
    createLiveEvent,
    wasLiveEventCreated: createLiveEventMutation.isSuccess,
    isCreatingLiveEvent: createLiveEventMutation.isLoading,
    responseData: createLiveEventMutation.isSuccess
      ? toLegacyFormat(createLiveEventMutation.data)
      : undefined,
  };
}
